import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import uuid from 'uuid/v4';
import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import { getMentionMap } from '@atlassian/ai-model-io/utils/mention-map';
import { getXProductHeader } from '@atlassian/editor-ai-common/api/request';
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var sanitizeUrl = function sanitizeUrl(url) {
  return url.replace(/[^\w\-/.:%?=]+/g, '');
};
export function getFullPageContent(_x2) {
  return _getFullPageContent.apply(this, arguments);
}
function _getFullPageContent() {
  _getFullPageContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var editorState, getMentionNameDetails, doc, schema, mentionMap, serializer;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          editorState = _ref.editorState, getMentionNameDetails = _ref.getMentionNameDetails;
          doc = editorState.doc, schema = editorState.schema;
          if (!getMentionNameDetails) {
            _context2.next = 6;
            break;
          }
          _context2.next = 5;
          return getMentionMap({
            node: doc,
            getMentionNameDetails: getMentionNameDetails
          });
        case 5:
          mentionMap = _context2.sent;
        case 6:
          serializer = new JSONTransformer(schema, mentionMap);
          return _context2.abrupt("return", _objectSpread({
            version: 1
          }, serializer.encodeNode(doc)));
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getFullPageContent.apply(this, arguments);
}
export function createRequestGenerator(_x) {
  return _createRequestGenerator.apply(this, arguments);
}
function _createRequestGenerator() {
  _createRequestGenerator = _wrapAsyncGenerator(function (_ref2) {
    var endpoint = _ref2.endpoint,
      product = _ref2.product,
      context = _ref2.context;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var editorView, locale, getMentionNameDetails, abortController, docContent, payload, startTime, response, result, triggers, errors, serializer, recommendations;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            editorView = context.view, locale = context.locale, getMentionNameDetails = context.getMentionNameDetails; // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // FIXME: Rather then removing all the work we added in S+G around queing limits and purging requests. I'm going to
            // set the limits to max value, this way the limits are not enforced and the BE just gets all changes always. This
            // way in future if they want to have limits we can just reset the limit settings.
            /**
             * QUEUE CONSTRAINTS:
             * Input size sum (all parts): 10,000 chars
             * Input size per part: 5,000 chars
             * Max parts: 50
             */
            abortController = new AbortController();
            _context.prev = 2;
            _context.next = 5;
            return _awaitAsyncGenerator(getFullPageContent({
              editorState: editorView.state,
              getMentionNameDetails: getMentionNameDetails
            }));
          case 5:
            docContent = _context.sent;
            payload = {
              ai_feature_input: {
                // Only add uncached paragraphs to requests, since cached ones have already been yielded
                triggers: [{
                  trigger_id: uuid(),
                  content_url: sanitizeUrl(document.location.href),
                  trigger_type: 'PARAGRAPH_COMPLETE',
                  paragraph_content: docContent
                }]
              }
            }; // track durations
            startTime = performance.now();
            _context.next = 10;
            return _awaitAsyncGenerator(fetch(endpoint, {
              method: 'POST',
              headers: _objectSpread({
                'Content-Type': 'application/json;charset=UTF-8',
                'X-Experience-Id': 'proactive-paragraph-complete',
                'Accept-Language': locale
              }, getXProductHeader(product)),
              body: JSON.stringify(payload),
              credentials: 'include',
              signal: abortController.signal,
              mode: 'cors'
            }));
          case 10:
            response = _context.sent;
            _context.next = 13;
            return {
              state: 'trackedDuration',
              duration: performance.now() - startTime
            };
          case 13:
            _context.next = 15;
            return _awaitAsyncGenerator(parseResponse(response));
          case 15:
            result = _context.sent;
            if (!(result.state === 'failed')) {
              _context.next = 22;
              break;
            }
            _context.next = 19;
            return result;
          case 19:
            _context.next = 21;
            return {
              state: 'done'
            };
          case 21:
            return _context.abrupt("return");
          case 22:
            triggers = result.body.ai_feature_output.triggers; // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // FIXME: This is not ideal, it checks for any errors in the response and then bails.
            // it would be nice to handle suggestions which are also included with the errors.
            errors = triggers.reduce(function (acc, trigger) {
              if ('errors' in trigger) {
                acc.push(trigger.errors.error_type);
              }
              return acc;
            }, []);
            serializer = new JSONTransformer(editorView.state.schema);
            recommendations = triggers.reduce(function (acc, trigger) {
              if ('recommendations' in trigger) {
                return acc.concat(trigger.recommendations.map(function (recommendation) {
                  var _recommendation$recom;
                  // XXX: We can only parse doc nodes, just in case the backend responds with a raw adf node which isn't encapsulated
                  // with a doc node then we will attempt correct this error before we parse it.
                  function getTransformContent(replacement_adf) {
                    var replacement = replacement_adf.type !== 'doc' ? {
                      version: 1,
                      type: 'doc',
                      content: [replacement_adf]
                    } : replacement_adf;
                    return {
                      // Warning -- document is asserted due to a mismatch in the editor-json-transformer and renderer types.
                      // JSONDocNode _should_ be runtime compatible with DocNode -- but does not have compatible types.
                      // See the following files for more details
                      // - packages/editor/editor-json-transformer/src/types.ts
                      // - packages/editor/adf-schema/src/schema/nodes/doc.ts
                      document: replacement,
                      getContent: function getContent() {
                        return serializer.parse(replacement).content;
                      }
                    };
                  }
                  return {
                    chunkId: trigger.trigger_id,
                    rid: recommendation.recommendation_id,
                    // XXX: We will not assume that the recommendation id is globally unique. However it should at minimum
                    // be unique to other local recommendations. We can make this id globally unique by prepending the
                    // trigger id which is gloabally unique.
                    id: "".concat(trigger.trigger_id, "_").concat(recommendation.recommendation_id),
                    transformContent: recommendation.transformation_details ? getTransformContent(recommendation.transformation_details.replacement_adf) : undefined,
                    transformType: recommendation.transformation_type,
                    transformAction: recommendation.recommendation_name,
                    details: recommendation.recommendation_details,
                    type: recommendation.recommendation_type,
                    score: (_recommendation$recom = recommendation.recommendation_score) !== null && _recommendation$recom !== void 0 ? _recommendation$recom : 0,
                    isViewed: false,
                    filtered: false
                  };
                }));
              }
              return acc;
            }, []);
            _context.next = 28;
            return {
              state: 'parsed',
              recommendations: recommendations
            };
          case 28:
            if (!errors.length) {
              _context.next = 31;
              break;
            }
            _context.next = 31;
            return {
              state: 'failed',
              reason: 'backend',
              errors: errors,
              statusCode: response.status
            };
          case 31:
            _context.next = 42;
            break;
          case 33:
            _context.prev = 33;
            _context.t0 = _context["catch"](2);
            if (!(_context.t0.name === 'AbortError')) {
              _context.next = 40;
              break;
            }
            _context.next = 38;
            return {
              state: 'failed',
              reason: 'aborted',
              errors: ['Streaming aborted'],
              statusCode: _context.t0.status
            };
          case 38:
            _context.next = 42;
            break;
          case 40:
            _context.next = 42;
            return {
              state: 'failed',
              reason: 'unhandled',
              errors: _context.t0 instanceof Error && ['RangeError', 'TypeError', 'TransformError'].includes(_context.t0.name) ? [_context.t0.message] : ['unhandled'],
              statusCode: _context.t0.status
            };
          case 42:
            _context.next = 44;
            return {
              state: 'done'
            };
          case 44:
            return _context.abrupt("return");
          case 45:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 33]]);
    })();
  });
  return _createRequestGenerator.apply(this, arguments);
}
function isValidResponse(response) {
  return _typeof(response) === 'object' && response !== null && 'ai_feature_output' in response;
}
function isErrorResponse(response) {
  return _typeof(response) === 'object' && response !== null && 'errorMessage' in response && 'errors' in response && 'statusCode' in response;
}
function parseResponse(_x3) {
  return _parseResponse.apply(this, arguments);
}
function _parseResponse() {
  _parseResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(response) {
    var _response$headers$get, retryAfter, body;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(response.status === 429)) {
            _context3.next = 3;
            break;
          }
          // The BE are unable to add the header due to constraints with the service proxy
          // There is a ticket to add this via feature request
          // https://hello.jira.atlassian.cloud/browse/SPSVC-28
          // For now we are just hard coding the value
          retryAfter = parseInt((_response$headers$get = response.headers.get('Retry-After')) !== null && _response$headers$get !== void 0 ? _response$headers$get : '');
          return _context3.abrupt("return", {
            state: 'failed',
            reason: 'rate-limited',
            // Retry-After is formatted in seconds, normalizing to milliseconds
            retryAfter: !isNaN(retryAfter) ? retryAfter * 1000 : undefined,
            statusCode: response.status,
            errors: ['tooManyRequests']
          });
        case 3:
          _context3.prev = 3;
          _context3.next = 6;
          return response.json();
        case 6:
          body = _context3.sent;
          if (!isValidResponse(body)) {
            _context3.next = 9;
            break;
          }
          return _context3.abrupt("return", {
            state: 'success',
            body: body
          });
        case 9:
          if (!isErrorResponse(body)) {
            _context3.next = 11;
            break;
          }
          return _context3.abrupt("return", {
            state: 'failed',
            reason: 'backend',
            errors: [body.errorMessage].concat(_toConsumableArray(body.errors)),
            statusCode: body.statusCode
          });
        case 11:
          _context3.next = 16;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](3);
          return _context3.abrupt("return", {
            state: 'failed',
            reason: 'parsing',
            errors: ['parsingError'],
            statusCode: response.status
          });
        case 16:
          if (response.body) {
            _context3.next = 18;
            break;
          }
          return _context3.abrupt("return", {
            state: 'failed',
            reason: 'network',
            errors: ['response.body missing'],
            statusCode: response.status
          });
        case 18:
          return _context3.abrupt("return", {
            state: 'failed',
            reason: 'backend',
            errors: ['Invalid response'],
            statusCode: response.status
          });
        case 19:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[3, 13]]);
  }));
  return _parseResponse.apply(this, arguments);
}